import axios from 'axios'

export default {
  async saveTranslations (project, locale, data) {
    try {
      const response = await axios.patch(`/projects/${project}/translations/${locale}`, data)
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return _.get(err, 'response.data', false)
    }
  },
  async importDictionary (project, locale, data) {
    try {
      const response = await axios.post(`/projects/${project}/translations/${locale}/import-dictionary`, data, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return _.get(err, 'response.data', false)
    }
  },
  async importAssets (project, locale, data) {
    try {
      const response = await axios.post(`/projects/${project}/translations/${locale}/import-assets`, data, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return _.get(err, 'response.data', false)
    }
  },
  async sendToAiTranslator (project, locale, data) {
    try {
      const response = await axios.post(`/projects/${project}/translations/${locale}/ai-translate`, data, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return err.errors ? err : { "errors" : _.get(err, 'response.data', false)}
    }
  },
  async refresh (project, locale) {
    try {
      const response = await axios.get(`/projects/${project}/translations/${locale}`)
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return _.get(err, 'response.data', false)
    }
  },
  async getDictionaryKeyLinks (project, dictKey) {
    try {
      const response = await axios.get(`/projects/${project}/translations/${dictKey}/get-links`)
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return _.get(err, 'response.data', false)
    }
  },
  async syncProjectKeys (project) {
    try {
      const response = await axios.post(`/projects/${project}/sync-translations`)
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return err.errors ? err : { "errors" : _.get(err, 'response.data', false)}
    }
  }
}